import React from 'react';
import { IQueryResult, IEntPhysiciansQueryParams, IEntPhysician } from 'gen/ApiClient';
import { IQueryContext } from 'framework/context/IQueryContext';

export const EntPhysiciansQueryContext = React.createContext<IQueryContext<IQueryResult<IEntPhysician>, IEntPhysiciansQueryParams>>(undefined as any);
